import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useLoja } from './LojaContext';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Package, Tv, Key, Search, Sparkles, ShoppingCart } from 'lucide-react';
import { toast } from 'sonner';

const iconMap = { tv: Tv, key: Key, package: Package };

export default function LojaHome() {
  const { API, addToCart } = useLoja();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCat, setSelectedCat] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/categories`),
      axios.get(`${API}/products`),
    ]).then(([c, p]) => {
      setCategories(c.data);
      setProducts(p.data);
    }).catch(() => toast.error('Erro ao carregar catálogo')).finally(() => setLoading(false));
  }, [API]);

  const filtered = products.filter(p => {
    if (selectedCat && p.category_id !== selectedCat) return false;
    if (search && !p.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div>
      <section className="mb-8 rounded-2xl p-8 bg-gradient-to-br from-fuchsia-600/20 via-purple-600/10 to-slate-900 border border-fuchsia-500/20">
        <div className="inline-flex items-center gap-2 text-xs font-medium text-fuchsia-300 bg-fuchsia-500/10 border border-fuchsia-500/20 px-3 py-1 rounded-full mb-4">
          <Sparkles className="w-3 h-3" /> Loja oficial MARKIMAGEM
        </div>
        <h1 className="text-3xl md:text-4xl font-black mb-2" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          Produtos digitais com entrega instantânea
        </h1>
        <p className="text-slate-400 max-w-xl">IPTV premium, ativações e mais — pagamento via PIX aprovado na hora.</p>
      </section>

      <div className="flex flex-col md:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar produtos..." className="pl-10 bg-slate-900 border-slate-800" />
        </div>
        <div className="flex gap-2 overflow-x-auto">
          <button onClick={() => setSelectedCat(null)} className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap ${!selectedCat ? 'bg-fuchsia-500 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}>Todas</button>
          {categories.map(c => {
            const Ico = iconMap[c.icon] || Package;
            return (
              <button key={c.id} onClick={() => setSelectedCat(c.id)} className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap flex items-center gap-1.5 ${selectedCat === c.id ? 'bg-fuchsia-500 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}>
                <Ico className="w-3.5 h-3.5" /> {c.name}
              </button>
            );
          })}
        </div>
      </div>

      {loading ? (
        <div className="text-center text-slate-400 py-16">Carregando...</div>
      ) : filtered.length === 0 ? (
        <div className="text-center text-slate-400 py-16">Nenhum produto encontrado.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map(p => (
            <Card key={p.id} className="bg-slate-900 border-slate-800 overflow-hidden hover:border-fuchsia-500/40 transition-colors flex flex-col">
              <Link to={`/loja/product/${p.id}`} className="block">
                <div className="aspect-video bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center">
                  {p.image_url ? (
                    <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
                  ) : (
                    <Package className="w-12 h-12 text-slate-600" />
                  )}
                </div>
              </Link>
              <div className="p-4 flex-1 flex flex-col">
                <Link to={`/loja/product/${p.id}`}><h3 className="font-semibold text-white hover:text-fuchsia-400 transition-colors">{p.name}</h3></Link>
                {p.description && <p className="text-xs text-slate-400 mt-1 line-clamp-2">{p.description}</p>}
                <div className="mt-auto pt-3 flex items-center justify-between">
                  <div className="text-lg font-black text-fuchsia-400">R$ {p.price.toFixed(2)}</div>
                  <Button size="sm" onClick={() => { addToCart(p); toast.success('Adicionado ao carrinho'); }} className="bg-fuchsia-500 hover:bg-fuchsia-600">
                    <ShoppingCart className="w-4 h-4 mr-1" /> Comprar
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
